<template>
  <div class="wrap">
    <ul>
      <li><span>姓名</span><input type="text"></li>
      <li class="last"><span>手机号</span><span>183****8598</span></li>
    </ul>
    <ul>
      <li><span>单位</span><input type="text"></li>
      <li><span>电子邮箱</span><input type="text" ></li>
      <li class="last"><span>职称</span><input type="text"/></li>
    </ul>
    <div class="enter">
      <span>保存</span>

    </div>


  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    props: {},
    methods: {

    },
    computed: {},
    mounted() {
      document.title = '个人信息'
    }
  }
</script>
<style scoped lang="scss">
  .wrap{
    min-height: 100vh;
    background: #F4F5F4;
    .enter{
      width: 7.5rem;
      margin-top: 0.4rem;
      height: 1rem;
      background: #ffffff;
      font-size: 0.32rem;
      font-family: 微软雅黑;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #e6e6e6;
      border-top: 1px solid #e6e6e6;
      color: #007EFF;
    }
    ul{
      background: #ffffff;
      border-top:1px solid  #E6E6E6;
      border-bottom:1px solid  #E6E6E6;
      padding-left: 0.32rem;
      box-sizing: border-box;
      font-size: 0.32rem;
      li{
        height: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e6e6e6;
        padding-right: 0.32rem;
        box-sizing: border-box;
        input{
          height: 0.98rem;
          box-sizing: border-box;
          border: none;
          outline: none;
          width: 4rem;
          text-align: right;
          font-size: 0.32rem;
          color: #333;
        }
        span{
          color: #666666;
          font-size: 0.32rem;
        }
      }
      .last{
        border: none;
      }
    }
    ul:nth-of-type(2){
      margin-top: 0.2rem;
      margin-bottom: 0.49rem;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/me/editingInfo.vue